import { CreateTicketComponent } from "./create/create.ticket.component";
import { EditTicketComponent } from "./edit.ticket.component";
import { ViewTicketComponent } from "./view/view.ticket.component";

export const TicketsDeclaration =[
    CreateTicketComponent,
    ViewTicketComponent,
    EditTicketComponent
]